import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import PastDueLogo from '../../../assets/images/pastDueLogo.png';

interface PastDueDueDateProps {
	formattedDate: string;
	isPastDue?: boolean;
}

export const dueDateTableCellSx: SxProps<Theme> = {
	minWidth: 260,
	width: '30%',
	whiteSpace: 'nowrap',
};

const PastDueDueDate = ({ formattedDate, isPastDue }: PastDueDueDateProps) => (
	<Box
		display="flex"
		alignItems="center"
		justifyContent="space-between"
		gap={1.25}
		flexWrap="nowrap"
		sx={{ minWidth: 240, whiteSpace: 'nowrap' }}
	>
		<Box component="span" sx={{ whiteSpace: 'nowrap', flexShrink: 0 }}>
			{formattedDate}
		</Box>
		{isPastDue ? (
			<Box
				component="img"
				src={PastDueLogo}
				alt="past due"
				height="30"
				sx={{ flexShrink: 0 }}
			/>
		) : null}
	</Box>
);

export default PastDueDueDate;
